import { createCheckboxIndicator } from './checkbox-indicator.js';

const PROVIDER_CHECKBOX_SELECTOR = [
  '#shopify-pc__prefs__dialog input[type="checkbox"]',
  '.restock-rocket-acknowledge-checkbox-input[type="checkbox"]',
].join(',');

const enhanceProviderCheckbox = (input) => {
  if (!(input instanceof HTMLInputElement) || input.dataset.sigmaCheckboxEnhanced === 'true') return;

  const containingLabel = input.closest('label');
  const owner = containingLabel || input.parentElement;
  if (!(owner instanceof HTMLElement)) return;

  const existingIndicator = containingLabel && [...containingLabel.children].find(
    (child) => child instanceof HTMLElement && child.matches('span') && child.querySelector('svg'),
  );
  const indicator = createCheckboxIndicator();

  if (existingIndicator && input.closest('#shopify-pc__prefs__dialog')) {
    // Shopify's change handler still updates its original checked/unchecked SVGs.
    // Keep them available without displaying a second checkbox indicator.
    existingIndicator.hidden = true;
    existingIndicator.style.display = 'none';
    existingIndicator.setAttribute('aria-hidden', 'true');
    existingIndicator.after(indicator);
  } else if (existingIndicator) existingIndicator.replaceWith(indicator);
  else input.insertAdjacentElement('afterend', indicator);

  owner.classList.add('sigma-checkbox-owner');
  input.classList.add('sigma-checkbox__native');
  input.dataset.sigmaCheckboxEnhanced = 'true';
};

const enhanceProviderCheckboxes = (root = document) => {
  if (root instanceof Element && root.matches(PROVIDER_CHECKBOX_SELECTOR)) enhanceProviderCheckbox(root);
  root.querySelectorAll?.(PROVIDER_CHECKBOX_SELECTOR).forEach(enhanceProviderCheckbox);
};

const mountedOwners = new WeakSet();

const mountIndicator = (indicator) => {
  const owner = indicator.closest('label, .sigma-checkbox-owner');
  if (!(owner instanceof HTMLElement) || mountedOwners.has(owner)) return;
  mountedOwners.add(owner);
  requestAnimationFrame(() => requestAnimationFrame(() => {
    owner.dataset.sigmaCheckboxMounted = 'true';
  }));
};

const mountIndicators = (root = document) => {
  if (root instanceof Element && root.matches('.sigma-checkbox')) mountIndicator(root);
  root.querySelectorAll?.('.sigma-checkbox').forEach(mountIndicator);
};

enhanceProviderCheckboxes();
mountIndicators();

new MutationObserver((records) => {
  records.forEach((record) => record.addedNodes.forEach((node) => {
    if (!(node instanceof Element)) return;
    enhanceProviderCheckboxes(node);
    mountIndicators(node);
  }));
}).observe(document.documentElement, { childList: true, subtree: true });
